import {secureGet} from "./http-module";

const FEATURE_URI = '/api/bff-feature/private/features';
let features;

const fetchUserFeatures = () => {
    return secureGet(FEATURE_URI).then(({ data }) => {
        return data.map(feature => ({ ...feature }));
    });
};

export const getUserFeatures = () => {
    if (!features) {
        features = fetchUserFeatures();
    }
    return features;
};
